import { render, staticRenderFns } from "./DiscernmentCar.vue?vue&type=template&id=540cd05a&scoped=true"
import script from "./DiscernmentCar.vue?vue&type=script&lang=js"
export * from "./DiscernmentCar.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentCar.vue?vue&type=style&index=0&id=540cd05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540cd05a",
  null
  
)

export default component.exports